import BookingAuthentication from "./BookingAuthentication";
export default BookingAuthentication;